@if (userInformations && organizationList && userForm) {
<div class="user-container">
    <div class="page-top-banner">
        <div class="title">
            {{
            isCreation
            ? (isAdminMode ? 'Création d’un administrateur' : 'Création d’un utilisateur')
            : (isAdminMode ? 'Fiche administrateur' : 'Fiche utilisateur')
            }}
            {{ userInformations.display ? '"' + userInformations.display + '"' : '' }}
        </div>
    </div>

    <div class="content">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
            <mat-tab-group>
                <mat-tab label="Informations générales">
                    <div formGroupName="generalGroup">
                        <mat-card class="box">
                            <mat-card-content>
                                <div class="form-preview-grid">
                                    <!-- COLONNE 1 : le formulaire -->
                                    <div class="form-grid">
                                        <mat-checkbox formControlName="enabled">Compte actif</mat-checkbox>
                                        @if (!isCreation) {
                                        <mat-form-field appearance="fill" disabled>
                                            <mat-label>Profil utilisateur</mat-label>
                                            <input matInput [value]="getUserProfil(userInformations) ?? '—'" disabled />
                                        </mat-form-field>
                                        }

                                        <!-- MODE CREATION USER CLASSIQUE (non admin) -->
                                        @if (isCreation && !isAdminMode) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Profil utilisateur</mat-label>
                                            <mat-select formControlName="profilId"
                                                (selectionChange)="onProfilSelected($event.value)">
                                                @for (profil of profils; track profil.id) {
                                                <mat-option [value]="profil.id">{{ profil.displayName || profil.name
                                                    }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        }
                                        <!-- MODE CREATION ADMINISTRATEUR -->
                                        @if (isCreation && isAdminMode) {
                                        <mat-form-field appearance="fill" disabled>
                                            <mat-label>Profil utilisateur</mat-label>
                                            <input matInput value="Administrateur" disabled />
                                        </mat-form-field>
                                        }

                                        <mat-form-field appearance="fill">
                                            <mat-label>Client</mat-label>
                                            <input matInput [value]="clientInput" readonly />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Nom</mat-label>
                                            <input matInput [value]="getPropertyValue('Lastname')"
                                                (input)="onTextInput('Lastname', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Prénom</mat-label>
                                            <input matInput [value]="getPropertyValue('Firstname')"
                                                (input)="onTextInput('Firstname', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Identifiant</mat-label>
                                            <input matInput formControlName="account" autocomplete="off" />
                                            @if (userForm.get('generalGroup.account')?.hasError('pattern')) {
                                            <mat-error>Format d'email invalide</mat-error>
                                            }
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Contact mail</mat-label>
                                            <input matInput [value]="getPropertyValue('Email')"
                                                (input)="onTextInput('Email', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Contact téléphone</mat-label>
                                            <input matInput [value]="getPropertyValue('Phone')"
                                                (input)="onTextInput('Phone', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Fonction</mat-label>
                                            <input matInput [value]="getPropertyValue('Function')"
                                                (input)="onTextInput('Function', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Adresse</mat-label>
                                            <input matInput [value]="getPropertyValue('Address')"
                                                (input)="onTextInput('Address', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Code postal</mat-label>
                                            <input matInput [value]="getPropertyValue('Zipcode')"
                                                (input)="onTextInput('Zipcode', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Ville</mat-label>
                                            <input matInput [value]="getPropertyValue('City')"
                                                (input)="onTextInput('City', $event)" />
                                        </mat-form-field>

                                        <mat-form-field appearance="fill">
                                            <mat-label>Pays</mat-label>
                                            <input matInput [value]="getPropertyValue('Country')"
                                                (input)="onTextInput('Country', $event)" />
                                        </mat-form-field>
                                    </div>

                                    <!-- COLONNE 2 : aperçu du profil sélectionné OU profil admin -->
                                    @if (isCreation && (selectedProfilProperties.length || isAdminMode)) {
                                    <div class="preview-box">
                                        <h3>Configuration du profil</h3>

                                        @for (prop of (isCreation ? selectedProfilProperties : userProperties); track
                                        prop.name) {
                                        <div class="property-radio-group">
                                            <div class="property-label">{{ prop.name }}</div>

                                            <mat-radio-group [value]="getNumericPropertyValue(prop.name)"
                                                (change)="onPropertyChanged(prop.name, $event.value)"
                                                name="{{ prop.name }}" class="radio-group-line" [disabled]="!canEdit">

                                                @for (option of getOptionsForProperty(prop.name); track option.value) {
                                                <mat-radio-button [value]="option.value">
                                                    {{ option.label }}
                                                </mat-radio-button>
                                                }
                                            </mat-radio-group>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </mat-tab>

                @if (!isCreation) {
                <mat-tab label="Propriétés">
                    <app-gum-properties [properties]="userProperties" [affinity]="affinity"
                        [isProfile]="currentUser.id === userInformations.id" (isValid)="propertiesValid = $event"
                        (changed)="onPropertiesChanged($event)">
                    </app-gum-properties>
                </mat-tab>
                }

            </mat-tab-group>

            <div class="buttons-band">
                <button mat-stroked-button class="accent-button" type="button"
                    (click)="cancelButtonClick()">Annuler</button>
                <button mat-raised-button class="accent-button" type="submit"
                    [disabled]="!canEdit || !userForm.valid || (!isCreation && !propertiesValid)">
                    Enregistrer
                </button>
            </div>
        </form>
    </div>
</div>
}

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="false"></ngx-spinner>